module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ext-form', {
    attrs: {
      "formData": _vm.formData,
      "submitProxy": _vm.proxy,
      "submitBtnText": "Регистрация"
    },
    on: {
      "submitSuccess": function($event) {
        _vm.$emit('submitSuccess')
      }
    }
  }, [_c('b-form-fieldset', {
    class: {
      'is-invalid': _vm.errors.has('login')
    },
    attrs: {
      "label": "Логин",
      "feedback": _vm.errors.first('login')
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|eng'),
      expression: "'required|eng'"
    }, {
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.formData.login),
      expression: "formData.login",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "name": "login"
    },
    domProps: {
      "value": (_vm.formData.login)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.login = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('b-form-fieldset', {
    class: {
      'is-invalid': _vm.errors.has('password')
    },
    attrs: {
      "label": "Пароль",
      "feedback": _vm.errors.first('password')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.password),
      expression: "formData.password"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "password",
      "type": "password"
    },
    domProps: {
      "value": (_vm.formData.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('b-form-fieldset', {
    class: {
      'is-invalid': _vm.errors.has('password2')
    },
    attrs: {
      "label": "Пароль повторно",
      "feedback": "Пароли не совпадают"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.replyPassword),
      expression: "formData.replyPassword"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('confirmed:password|required'),
      expression: "'confirmed:password|required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "password2",
      "type": "password"
    },
    domProps: {
      "value": (_vm.formData.replyPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.replyPassword = $event.target.value
      }
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70d508ca"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/forms/CreateAccountForm.vue
// module id = 236
// module chunks = 1